// src/frontend/pages/CourseLanding.jsx
import React, { useMemo } from "react";
import { useParams, Link, useNavigate } from "react-router-dom";
import booksData from "../data/books.json";

const slugify = (s="") =>
  String(s).toLowerCase().normalize("NFD").replace(/\p{Diacritic}/gu,"")
  .replace(/[^a-z0-9]+/g,"-").replace(/^-+|-+$/g,"");

export default function CourseLanding() {
  const { slug } = useParams();
  const nav = useNavigate();
  const books = Array.isArray(booksData) ? booksData : [];
  const normalized = useMemo(() =>
    books.map(b => ({...b, _slug: b.slug || b.id || slugify(b.title || "")})), [books]
  );
  const book = normalized.find(b => b._slug === slug);

  const styles = {
    wrap:{maxWidth:"1100px",margin:"0 auto",padding:"24px"},
    header:{display:"flex",justifyContent:"space-between",alignItems:"center",gap:"12px"},
    h1:{fontSize:"1.8rem",margin:0,color:"#0f172a"},
    cta:{padding:"12px 18px",borderRadius:"12px",background:"#1554ff",color:"#fff",
      textDecoration:"none",fontWeight:800,border:"none",cursor:"pointer"},
    grid:{display:"grid",gridTemplateColumns:"1fr 360px",gap:"24px",marginTop:"18px"},
    card:{background:"#fff",border:"1px solid #e5e7eb",borderRadius:"14px",padding:"16px"},
    cover:{width:"100%",height:"200px",objectFit:"cover",borderRadius:"12px",background:"#0b1220"},
    sectionTitle:{fontSize:"1rem",fontWeight:800,color:"#0f172a",margin:"0 0 12px"},
    list:{display:"grid",gap:"8px",listStyle:"none",padding:0,margin:0},
    item:{border:"1px solid #e5e7eb",borderRadius:"12px",padding:"10px 12px",background:"#fff"},
    link:{textDecoration:"none",color:"#111827"},
    back:{display:"inline-block",marginTop:"8px",color:"#1554ff",textDecoration:"none"},
  };

  if (!book) {
    return (
      <section style={styles.wrap}>
        <h2>No encontrado</h2>
        <Link to="/course/books" style={styles.back}>← Volver</Link>
      </section>
    );
  }

  const chapters = Array.isArray(book.chapters) ? book.chapters : [];
  const start = () => nav(`/course/reader/${book._slug}/0`);

  return (
    <section style={styles.wrap}>
      {/* Encabezado con CTA "Continuar curso" */}
      <div style={styles.header}>
        <h1 style={styles.h1}>{book.title}</h1>
        <button style={styles.cta} onClick={start}>Continuar curso</button>
      </div>

      <div style={styles.grid}>
        {/* Columna izquierda: descripción e índice */}
        <div className="left">
          <div style={styles.card}>
            <h3 style={styles.sectionTitle}>Información del curso</h3>
            <p>{book.description}</p>
          </div>

          <div style={{...styles.card, marginTop:"16px"}}>
            <h3 style={styles.sectionTitle}>Contenido del curso</h3>
            <ul style={styles.list}>
              {chapters.map((c, i) => (
                <li key={i} style={styles.item}>
                  {/* cada capítulo puede abrir el lector en ese índice */}
                  <Link to={`/course/reader/${book._slug}/${i}`} style={styles.link}>
                    {c.index ? `${c.index}. ` : ""}{c.title}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <Link to="/course/books" style={styles.back}>← Volver a la biblioteca</Link>
        </div>

        {/* Columna derecha: portada */}
        <aside>
          <div style={styles.card}>
            <img
              src={book.cover || "/assets/books/placeholder.jpg"}
              alt={book.title}
              style={styles.cover}
            />
          </div>
        </aside>
      </div>
    </section>
  );
}
